export const APP_LINKS = {
  website: "https://stalkie.app",
  terms: "https://stalkie.app/terms",
  privacy: "https://stalkie.app/privacy",
} as const;

export const APP_EMAILS = {
  support: "support@stalkie.app",
  privacy: "privacy@stalkie.app",
} as const;

export const APP_MAILTO = {
  support: `mailto:${APP_EMAILS.support}`,
  reportProblem: `mailto:${APP_EMAILS.support}?subject=Report%20Problem`,
} as const;
